import React from "react";
import { FieldsList } from "./FieldsList";
import { ModulesList } from "./ModulesList";

const TEMP_isExistingSubmission = false;

export function FieldsTab() {
  return (
    <>
      <FieldsList />
      {!TEMP_isExistingSubmission && <ModulesList />}
    </>
  );
}
